import { ChecklistCriteria, Section } from "types/Checklist";
import { CellTextParagraphs } from "types/WordChecklist";
import { usePDFChecklistCriteriaGenerator } from "./usePDFChecklistCriteriaGenerator";

export const usePDFChecklistSectionGenerator = (
  section: Section,
  allRows: any[],
  allCriteria: ChecklistCriteria[],
  isNested: boolean,
  numParagraphs: number,
  numParagraphColumns: number,
  cellTextToParagraphs: CellTextParagraphs[],
  showParagraphColumns: boolean = false,
  hideScores: boolean = false,
  includeCriteriaCheckmarks: boolean = false,
  isStudentMode: boolean = false
) => {
  var cells = [] as any[];

  if (isNested == true) {
    cells.push({
      text: "",
    });
  }

  var columnSpan = 0;
  var numParagraphsToUse =
    section.paragraphPositionsData && section.paragraphPositionsData.length > 0
      ? section.paragraphPositionsData.length
      : numParagraphColumns;

  if (section.displayParagraphColumns || showParagraphColumns) {
    columnSpan = isNested ? 1 : 2;
  } else {
    columnSpan = isNested ? 2 : 3;
  }

  cells.push({
    text: section.title,
    fillColor: "#dddddd",
    bold: true,
    colSpan: columnSpan,
  });

  // add empty {} for olumnSpan - 1
  for (var i = 1; i < columnSpan; i++) {
    cells.push({});
  }

  if (section.displayParagraphColumns) {
    var index = 1;

    var sectionParagraphPositionsData = section.paragraphPositionsData;

    var sectionColSpan = Math.floor(numParagraphColumns / numParagraphsToUse);

    var totalColumns = 0;

    const scoreCells: any[] = [];

    while (index <= numParagraphsToUse) {
      totalColumns += sectionColSpan;

      var paragraphLabel = `P${index}`;

      if (
        sectionParagraphPositionsData &&
        sectionParagraphPositionsData[index - 1]
      ) {
        paragraphLabel = sectionParagraphPositionsData[index - 1].shortLabel;
      }

      // If the current key is the last keym and the total columns isn't yet equal to numParagraphs
      // Then we need to set columnSpan to the difference between numParagraphs and totalColumns
      if (
        index == numParagraphsToUse - 1 &&
        totalColumns != numParagraphColumns
      ) {
        sectionColSpan += numParagraphsToUse - totalColumns;
      }

      scoreCells.push({
        text: paragraphLabel,
        alignment: "center",
        bold: true,
        fillColor: "#dddddd",
        fontSize: 12,
      });
      index++;
    }

    const scoreTable = {
      table: {
        widths: scoreCells.map(() => "*"),
        body: [scoreCells],
      },
      layout: {
        hLineWidth: function (i: any, node: any) {
          return 0; // No horizontal lines
        },
        vLineWidth: function (i: any, node: any) {
          // Add right border to the first two cells
          if (i > 0 && i < numParagraphsToUse) {
            return 0.5; // Adjust the width as needed
          } else {
            return 0;
          }
        },
        vLineColor: function (i: any, node: any) {
          if (i > 0 && i < numParagraphsToUse) {
            return "black"; // Adjust the color as needed
          }
        },
        paddingLeft: function (i: any, node: any) {
          return 0;
        },
        paddingRight: function (i: any, node: any) {
          return 0;
        },
        paddingTop: function (i: any, node: any) {
          return 0;
        },
        paddingBottom: function (i: any, node: any) {
          return 0;
        },
      },
      fillColor: "#dddddd",
    };

    cells.push(scoreTable);
  }

  if (showParagraphColumns && section.displayParagraphColumns != true) {
    var index = 1;

    var sectionColSpan = Math.floor(numParagraphColumns / numParagraphsToUse);

    var totalColumns = 0;
    cells.push({
      text: "",
      fillColor: "#dddddd",
    });
  }

  allRows.push(cells);

  for (var criteriaInstance of section.criteriaInstances) {
    var criteriaRows = usePDFChecklistCriteriaGenerator(
      criteriaInstance,
      allCriteria,
      numParagraphs,
      numParagraphColumns,
      cellTextToParagraphs,
      "#000000",
      hideScores,
      includeCriteriaCheckmarks,
      isStudentMode
    );
    allRows.push(...criteriaRows);
  }

  if (section.sections) {
    for (var nestedSection of section.sections) {
      var copiedSection = { ...nestedSection };

      if (
        copiedSection.paragraphPositionsData == undefined &&
        section.paragraphPositionsData &&
        section.paragraphPositionsData.length > 0
      ) {
        copiedSection.paragraphPositionsData = section.paragraphPositionsData;
      }

      usePDFChecklistSectionGenerator(
        copiedSection,
        allRows,
        allCriteria,
        true,
        numParagraphs,
        numParagraphColumns,
        cellTextToParagraphs,
        section.displayParagraphColumns,
        hideScores,
        includeCriteriaCheckmarks,
        isStudentMode
      );
    }
  }
};
